// extracted by mini-css-extract-plugin
export default {"FlatPreviewList":"FlatPreviewList_FlatPreviewList__4mxd6"};